import React from 'react';
interface StickyButtonProps {
  onClick: () => void;
}
export const StickyButton: React.FC<StickyButtonProps> = ({
  onClick
}) => {
  return <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 p-4 bg-white border-t border-gray-200 shadow-lg" data-id="element-285">
      <button onClick={onClick} className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-6 rounded-lg transition duration-200 text-center shadow-md" data-id="element-286">
        Aanmelden gratis webinar over hondencommunicatie
      </button>
    </div>;
};